"use client";

import Badge from "~/componentsDS/Badge";
import { QuizCTA } from "~/components/features/quiz";
import { Carousel } from "~/componentsDS/Carousel";
import ElementorContainer from "~/componentsDS/ElementorLoyout/ElementorContainer";
import Container from "~/componentsDS/Layout/Container";
import Reveal from "~/componentsDS/Reveal";
import Heading from "~/componentsDS/Typography/Heading";
import Paragraph from "~/componentsDS/Typography/Paragraph";
import { CarouselContentVisible, CarouselItem } from "~/components/ui/carousel";
import { GTM_EVENT_NAMES } from "~/constants/gtmEvents";
import { QUIZ_ROUTES } from "~/constants/quizRoutes";
import { cn } from "~/lib/utils";
import SourceCard from "../components/SourceCard";
import { SOURCE_CARDS } from "~/componentsDS/LPComponents/data";

type Props = {
    sectionClassName?: string;
    buttonClassName?: string;
}

const SourcesSection = ({sectionClassName, buttonClassName}: Props) => {
    const getElementorOffset = (viewSize: number) => {
        if (viewSize >= 1728) return 144;
        if (viewSize >= 1440) return 80;
        if (viewSize >= 1280) return 64;
        if (viewSize >= 1025) return 48;

        return 24;
    };
    return (
        <section className={cn("pt-12 md:pt-12 md:pb-1 font-suisseBP text-primary500", sectionClassName)}>
            <ElementorContainer innerClassName="flex flex-col">
                <Reveal>
                    <Badge className="mb-4 font-medium">Our sources</Badge>
                    <Heading as="h2" size="sm" sizes={{ md: "md" }} className="text-primary500">
                        Designed for <br className="md:hidden" /> long-term{" "}
                        <span className="italic text-[28px] md:text-[36px] font-featureDisplay font-normal">confidence</span>
                    </Heading>
                </Reveal>

                <Paragraph className="max-w-[516px] text-[18px] leading-[1.35]">
                    Oestra<sup>®</sup> is a prescription bioidentical hormone therapy
                    compounded to rigorous U.S. standards.
                </Paragraph>

                <Paragraph className="max-w-[516px] text-[18px] font-medium leading-[1.35]">
                    What&apos;s inside — and how it&apos;s made — matters.
                </Paragraph>

            </ElementorContainer>

            <div className="box-content mt-4 md:mt-8 overflow-hidden">
                <Carousel
                    opts={{
                        align: (viewSize) => getElementorOffset(viewSize),
                        skipSnaps: false,
                        loop: true,
                    }}
                    className="w-full mx-auto"
                >
                    <CarouselContentVisible className="ml-[-10px]">
                        {SOURCE_CARDS.map((card) => (
                            <CarouselItem
                                key={card.id}
                                className="flex-shrink-0 pl-[10px] basis-[88%] md:basis-[600px]"
                            >
                                <SourceCard card={card} />
                            </CarouselItem>
                        ))}
                    </CarouselContentVisible>
                </Carousel>
            </div>
            <Container>
                <div className={cn("mt-8 md:hidden", buttonClassName)}>
                    <QuizCTA
                        className="px-8 w-full"
                        href={QUIZ_ROUTES.HORMONE_IMBALANCE}
                        eventData={{
                            event_name: GTM_EVENT_NAMES.LP_INTERACTION,
                            widget: "our_sources",
                            meta_data: {
                                click_text: "See If Oestra® Is Right for You",
                            },
                        }}
                    >
                        <span className="inline-block">
                            See If Oestra<sup>®</sup> Is Right for You
                        </span>
                    </QuizCTA>
                </div>
            </Container>
        </section>
    );
}

export default SourcesSection
